import BackgroundImageLoader from '@components/imageModules/backgroundImageLoader'
import Polaroid1 from '@components/imageModules/v5/polaroid1'
import { IMAGELOADINGENUMS } from '@et/types/Enums'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { classNames } from '@utils/genUtils'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import { IWYLItem, WYLItemEnums } from './whatYoullLearnV5'
import { twMerge } from 'tailwind-merge'

interface Props {
  index: number
  item: IWYLItem
  itemClasses?: {
    titleClasses: string
    textClasses: string
  }
  frameImage?: boolean
  textBottom?: boolean
  isLastItem?: boolean
}

function WhatYoullLearnItemV5(props: Props) {
  const { item, itemClasses, index, frameImage, textBottom = false, isLastItem } = props
  const containerLocationCss = index === 0 ? 'md:col-start-7 md:col-span-6 md:row-start-2' : ''

  // if its the 2nd index item, then add a classes to it
  const item2 = index === 1 ? 'lg:row-start-2' : ''

  const itemEvenCss = index % 2 !== 0 ? ' md:col-start-1 md:col-span-6' : ' md:col-start-7 md:col-span-6'

  const backgroundClass = item.bg ? item.bg.classes : ''

  if (item.imageOnly) {
    const { image, classes, type } = item.imageOnly

    // First small square image or the 2nd large square
    const itemGridType = type === WYLItemEnums.TYPE1 ? 'lg:col-start-9 lg:col-span-4 lg:row-start-3' : 'lg:col-start-1 lg:col-span-8 lg:row-start-5 lg:row-span-2'

    return (
      <div className={classNames(classes ? classes : '', `wyl-itemV5-imageOnly p-0 bg-transparent shadow-none hidden lg:block ${itemGridType}`)}>
        <Polaroid1 image={image} frame={frameImage} />
      </div>
    )
  }


  return (
    <div className={classNames(item.bg ? '' : 'pt-5 pb-6 px-6', `wyl-itemV5 relative col-start-2 col-span-2 mb-5 flex flex-col shadow-[0_4px_6px_rgba(50,50,93,.11),0_1px_3px_rgba(0,0,0,.08)] md:mb-0 lg:col-span-4 ${containerLocationCss} ${itemEvenCss} ${item2} ${backgroundClass}`)}>

      {!item.bg && item.image && <div className='wyl-itemV5-icon'>
        <GatsbyImage
          loading={IMAGELOADINGENUMS.LAZY}
          image={item.image.gatsbyImageData}
          alt={item.title} />
      </div>}

      <div className={classNames(item.bg ? 'h-full' : '', 'wyl-itemV5-content')}>

        {item.bg && <BackgroundImageLoader
          showBlurImage={false}
          gatsbyDataImg={item.bg.image.gatsbyImageData} />}

        <div className={twMerge(item.bg
          ? textBottom
            ? `text-center h-full flex flex-col pb-12 pt-52 px-10 ${index === 0 || index === 2 || index === 3 || isLastItem ? 'justify-end' : 'justify-start'}`
            : 'justify-center text-center h-full flex flex-col py-32 px-10'
          : '', 'relative z-2')}>

          <h3 className={classNames(itemClasses ? itemClasses.titleClasses : '', `my-3 font-bold font-sentinel__SemiBoldItal text-3xl lg:text-2xl ${item.className}`)}>{item.title}</h3>
          <p className={classNames(itemClasses ? itemClasses.textClasses : '', `${item.className}`)}>{item.desc}</p>

        </div>
      </div>
    </div>
  )
}

export default WhatYoullLearnItemV5
